import hexToRgb from './hexToRgb';
import isObject from '../isObject';
import isString from '../isString';

function getColorLuma(color) {
  let c = {};
  
  if (isString(color)) {
    c = hexToRgb(color);
  } else if (isObject(color)) {
    c = color;
  }
  
  return 0.2126 * c.r + 0.7152 * c.g + 0.0722 * c.b;
}

export default getColorLuma;